import type { NodeDefinition } from '../../../types/node-definition';

const definition: NodeDefinition = {
  type: 'split-in-batches',
  name: 'Split In Batches',
  category: 'utilities',
  description: 'Split data into smaller batches for processing large datasets',
  icon: 'SplitSquareHorizontal',
  color: 'cyan',
  version: '3.0.0',
  
  group: ['transform'],
  
  defaults: {
    name: 'Split In Batches',
    color: '#06b6d4'
  },
  
  inputs: [
    {
      name: 'default',
      type: 'main',
      displayName: 'Input',
      required: true
    }
  ],
  
  outputs: [
    {
      name: 'done',
      type: 'main',
      displayName: 'Done'
    },
    {
      name: 'loop',
      type: 'main',
      displayName: 'Loop'
    }
  ],

  tags: ['split', 'batch', 'chunk', 'paginate', 'loop', 'iterate'],

  metadata: {
    documentation: 'https://docs.n8n.io/integrations/builtin/core-nodes/n8n-nodes-base.splitinbatches/'
  }
};

export default definition;
